import { sendMessage, setReceivedCallback, setStatusCallback, refreshLock, takeOver, save } from "admin/channels/editor";

// elements
import Side2Element from 'admin/editor/components/side2';
import ButtonElement from 'admin/editor/components/button';
import CollapsibleElement from 'admin/editor/components/collapsible';
import EmbedElement from 'admin/editor/components/embed';
import AlertElement from 'admin/editor/components/alert';
import RawElement from 'admin/editor/components/raw';
import CodeElement from 'admin/editor/components/code';
import TextElement from 'admin/editor/components/text';
import TemplateElement from 'admin/editor/components/template';
import MediaElement from 'admin/editor/components/media';
import GuideElement from 'admin/editor/components/guide';
import SplitPageElement from 'admin/editor/components/split_page';
import TableElement from 'admin/editor/components/table';
import ProductElement from 'admin/editor/components/product';
import MarkdownElement from 'admin/editor/components/markdown';
import PartsElement from 'admin/editor/components/parts';
import StuffsheetElement from 'admin/editor/components/stuffsheet';

import "blueimp-file-upload/js/jquery.fileupload.js";
import tinymce from 'tinymce/tinymce';
import 'tinymce/models/dom';
import 'tinymce/icons/default';
import 'tinymce/themes/silver/theme';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/code';
import 'tinymce/plugins/link';
import 'tinymce/plugins/wordcount';

import 'vendor/tinymce/plugins/spoiler/plugin';

require.context('!file-loader?name=[path][name].[ext]&context=vendor/tinymce/skins!tinymce/skins', true, /.*/);
require.context('!file-loader?name=[path][name].[ext]&context=vendor/tinymce/plugins!tinymce/plugins', true, /.*/);

import DividerIcon from 'assets/images/divider_icon.gif';
import PlaceHolderStripes from 'assets/images/placeholder_stripes.gif';

var sortable_options;
var $replace_image_element;
var templates = {
  'button_bar': '<div class="button-bar dropzone">' +
                  '<div class="button-bar-buttons">' +
                    '<div class="title-text">Choose an element to insert</div>' +
                      '<div class="buttons">' +
                      '<div class="clear"></div>' +
                    '</div>' +
                    '<a class="cancel" href="#">X</a>' +
                    '<div class="clear"></div>' +
                  '</div>' +
                  '<div class="button-bar-dropzone"><div><i class="fa fa-picture-o"></i><br/>Drag and drop media files here</div></div>' +
                  '<input id="drop-paste-image" class="button secondary" type="file" name="files" style="display:none;">' +
                '</div>',
  'editor_button_line': '<div class="editor-button-line">' +
                          '<div class="border-line"></div>' +
                          '<a href="#" class="enable-editor-buttons">' +
                            `<img src="${DividerIcon}">` +
                          '</a>' +
                        '</div>',
  'image_placeholder': `<img src="${PlaceHolderStripes}" class="image-uploading img-responsive" />`
};

var LearnEditor = function( element, options ){
    this.element = element;
    this.$element = $(this.element);
    this.options = options;

    // state
    this.editor_locked = true;
    this.save_in_progress = false;
    this.editing_element = false;

    // This next line takes advantage of HTML5 data attributes
    // to support customization of the plugin on a per-element
    // basis. For example,
    // <div class=item' data-plugin-options='{"message":"Goodbye World!"}'></div>
    this.metadata = this.$element.data( 'plugin-options' );
    this.saved_text = '';
    this.activeElementID;
    this.pageID = $('input[name$="page_id"]').val();
    this.username = $('#account .name').data('username');
    this.saveFinish;
    this.saveStart;
    this.saveTimeout;
    // save with the action cable functionality instead of ajax
    this.saveWithCable = false;
  };

// the plugin prototype
LearnEditor.prototype = {
  defaults: {
    message: 'Editor Enabled'
  },

  init: function() {
    var that = this;

    this.init_cable();
    this.setElements();

    this.session_keep_alive();
    this.edits_in_progress_notifier();
    this.inject_button_bars();
    this.disableEditor();
    this.handle_button_bar_display();
    this.button_listener();
    this.page_title_handler();
    this.init_tinymce();
    this.$element.trigger('editor-loaded');

    this.refresh_lock();
    this.affix_sidebar();

    sortable_options = {
      connectWith: ['.sortable'],
      helper : 'clone',
      delay : 120,
      start: function() {
        // removing these throws an error in the console, but doesn't
        // appear to cause any issues. The error is due to the items being
        // absent when sortable loops through them.
        $('.editor-table-outer-links').remove();
        $('.editor-table-add-row').remove();
        $('.editor-table-add-column').remove();
        $('.editor-table-delete-table').remove();
        that.disableEditor(true);
      },
      update: function(event, ui) {
        if (this === ui.item.parent()[0]) {
          that.save_page("Before Sorted Element");
        }
      }
    };

    $(".sortable").sortable(sortable_options);

    return this;
  },

  editing: function() {
    this.editing_element = true;
    this.disableEditor();
  },

  finishEditing: function() {
    this.editing_element = false;
    this.enableEditor();
  },

  enableEditor: function() {
    if (!this.is_editor_enabled()) {
      this.inject_button_bars();
      // disable sortable and then reenable
      $(".sortable").each(function() {
        if ($(this).data( "ui-sortable" )) {
          $(this).sortable("destroy");
        }
      });
      $(".sortable").sortable(sortable_options);

      this.enable_bottom_button_bar(true);
      this.$element.trigger('enabled');
    }
  },

  disableEditor: function(sortable = false) {
    if (!sortable) {
      // disable sortable
      $(".sortable").each(function() {
        if ($(this).data( "ui-sortable" )) {
          $(this).sortable("destroy");
        }
      });
    }
    $('.alert-js').hide();

    this.remove_button_bars()
    this.enable_bottom_button_bar(false);
    this.$element.trigger('disabled');
  },

  setElements: function() {
    this.elements = [
      new TextElement({editor: this}),
      new MediaElement({editor: this}),
      new CodeElement({editor: this}),
      new EmbedElement({editor: this}),
      new AlertElement({editor: this}),
      new CollapsibleElement({editor: this}),
      new Side2Element({editor: this}),
      new ButtonElement({editor: this}),
      new TableElement({editor: this}),
      new StuffsheetElement({editor: this}),
      new RawElement({editor: this}),
      new ProductElement({editor: this}),
      new MarkdownElement({editor: this}),
      new PartsElement({editor: this}),
      new GuideElement({editor: this}),
      new TemplateElement({editor: this}),
      new SplitPageElement({editor: this})
    ]
  },

  set_watchlist: function(data) {
    $('#editor-status .editor-watchlist').remove();
    if (data.length) {
      data.forEach(function(user) {
        var $template = $("<li class='editor-watchlist'></li>");
        $('#editor-status').append($template.html(user + "<i class='fa fa-eye'></i>"));
      });
    }
  },

  set_lock: function(data, revoked_username = null) {
    if (data != null && data.username) {
      $('#editor-lock').show();

      if (this.username !== data.username) {
        $('#editor-lock .user').text(data.username + " is editing")
                         .addClass('locked');
        $('#editor-lock .status').text("You are locked out of this page");
        $('#editor-lock .revoke').show();

        if (revoked_username === this.username) {
          alert(`${data.username} has taken over and is currently editing.`);
        }

        // someone else is editing right now
        this.editor_locked = true;
        this.disableEditor();
      } else {
        $('#editor-lock .user').text("You are editing")
                         .removeClass('locked');
        $('#editor-lock .status').text("This page is locked for others");
        $('#editor-lock .revoke').hide();


        if (this.editor_locked) {
          this.editor_locked = false;
          this.enableEditor();
        }
      }
    } else {
      this.refresh_lock();
    }
  },

  init_cable: function() {
    var self = this;
    setReceivedCallback(data => {
      if (!data) return;

      if (data.lock) {
        self.set_lock(data.lock, data.revoked_username);
      }

      if (data.watchlist) {
        self.set_watchlist(data.watchlist);
      }

      if (data.save_response) {
        self.save_response(data.save_response);
      }

      if (window.DEBUG) {
        console.log(data);
      }
    });

    setStatusCallback(data => {
      self.set_publish_text(data.status, data.keep, data.error);

      if (data.status === "Disconnected") {
        $('#editor-lock .user').text("You are not connected")
                               .addClass('locked');
        $('#editor-lock .status').text('Refresh this page to edit');
      }

      if (window.DEBUG) {
        console.log(data);
      }
    });

    $('#editor-lock .revoke').on('click', function() {
      if (confirm("Are you sure you would like to take over editing of this page?")) {
        takeOver();
      }
    });
  },

  refresh_lock: function() {
    var that = this;
    setInterval(function() {
      refreshLock();
    }, 14 * 1000);
  },

  affix_sidebar: function() {
    var affix_timer;
    var affixed = false;
    var $sidebar = $('.sidebar-right');

    var affixFn = function() {
      $(window).off('.affix');
      $sidebar.removeClass("affix affix-top affix-bottom").removeData("bs.affix");

      //sidebar needs to be fully visible in the window.
      if (($sidebar.outerHeight(true) < $(window).height()) && ($(window).width() > 768)) {
        var messageHeight = $('#messaging-alert').is(":visible") ? $('#messaging-alert').outerHeight(true) : 0;
        //affix the sidebar.
        $sidebar.affix({
          offset: {
            top: function () {
              return (this.top = ($('#adafruit-header').outerHeight(true) + messageHeight));
            },
            bottom: function () {
              return (this.bottom = ($('#adafruit-footer').outerHeight(true) + 60));
            }
          }
        });

        $sidebar.css('width', $sidebar.innerWidth());
      }
    };

    affixFn();
    $(window).on('resize', function() {
      clearTimeout(affix_timer);
      affix_timer = setTimeout(affixFn, 100);
    });
  },

  tinymce_options: function() {
    return {
      contextmenu: "link style-code",
      plugins: "lists autolink code link spoiler stylebuttons",
      toolbar: "undo redo | styles | bold italic underline | alignleft aligncenter alignright justify | bullist numlist link style-code blockquote | outdent indent code spoiler-toggle",
      height: "375",
      contextmenu: false,
      skin_url: '/packs/skins/ui/oxide',
      skin: 'oxide',
      menubar: false,
      browser_spellcheck: true,
      toolbar_items_size: 'small',
      invalid_elements: 'div',
      extended_valid_elements: 'span[*]',
      resize: true,
      statusbar: false,
      branding: false,
      promotion: false,
      content_css : ["/altstyles/custom-tinymce.css?" + new Date().getTime(), "/altstyles/fonts.css"],
      convert_urls: false,
      init_instance_callback: function() {
        tinymce.activeEditor.focus();
      }
    };
  },

  init_tinymce: function() {
    // modified from: https://blog.ionelmc.ro/2013/10/17/tinymce-formatting-toolbar-buttons/
    tinymce.PluginManager.add('stylebuttons', function(editor, url) {
      // can add more in the future, if editors want the feature on the toolbar
      // ['pre', 'p', 'code', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']
      editor.ui.registry.addButton("style-code", {
        tooltip: "Toggle Code",
        icon: 'code-sample',
        onAction: function(_) { editor.execCommand('mceToggleFormat', false, 'code'); },
      });
    });

    tinymce.dom.Event.domLoaded = true;
    tinymce.init(this.tinymce_options());
  },

  clear_publish_text: function() {
    $('#editor-connection').text('Connected').removeClass('error');
  },

  edits_in_progress_notifier: function() {
    var self = this;
    //make sure user really wants to leave with pending edits in place
    $(window).on('beforeunload', function() {
      var is_editor_page = (location.pathname.indexOf("editor") != -1);
      if (self.prevent_navigation() && is_editor_page) {
        return 'You have pending edits. Please save prior to leaving.';
      }
    });
  },

  session_keep_alive: function() {
    var is_connected = true;
    function ping_server() {
      $.get( "/editor/keepalive", function( data ) {
        is_connected = true;
      }).fail(function() {
        is_connected = false;
        alert( "There was an error communicating with the server. Please preview to see what has been saved and backup your work." );
      });
    }

    //only run keep alive in the editor
    if (this.$element.length > 0) {
      setInterval(function() {
        if (is_connected) {
          ping_server();
        }
      }, 120000);
    }
  },

  //injects overlay and js for when the image on a side-by-side needs to be cropped
  //shows overlay
  crop_image: function(result) {
    this.$element.after(result);
    $('#cropModal').modal('show');
  },

  button_color_handler: function(event) {
    event.preventDefault();

    $(this).siblings().removeClass('active');
    $(this).addClass('active');
  },

  renderButtonBar: function() {
    var $button_bar = $(templates.button_bar)

    this.elements.forEach(element => {
      if (element.shouldShowButton()) {
        $button_bar.find('.buttons').append(element.addButtonTemplate());
      }
    });

    return $button_bar;
  },

  addButtonBar: function(element) {
    if (this.is_editor_enabled()) {
      return;
    }

    element.replaceWith(this.renderButtonBar());
    this.$element.trigger('button-bar-added');

    $('.button-bar').show('clip', 100, function() {
    //  $button_line.remove();
    });

    var that = this;
    //cancel button bar
    $('.button-bar .cancel').on('click', function(event) {
      event.preventDefault();

      $(this).closest('.button-bar').remove();
      that.enableEditor();
    });
  },

  button_listener: function() {
    var that = this;
    function display_button_bar(event) {
      event.preventDefault();


      //remove any existing button-bars
      $('.button-bar').replaceWith(templates.editor_button_line);

      that.addButtonBar($(event.target).closest('.editor-button-line'));

    }

    $(document).on('click', '.enable-editor-buttons', display_button_bar);

    //currently used by the big button, and alert
    $(document).on('click', '.editor-add-colors button', that.button_color_handler);
  }

};

LearnEditor.prototype.set_publish_text = function(update_text, should_keep_text, add_error_class) {
  var that = this;
  if (!update_text) {
    return;
  }

  $('#editor-connection').text(update_text);

  if (add_error_class) {
    $('#editor-connection').addClass('error');
  } else {
    $('#editor-connection').removeClass('error');
  }

  if (!should_keep_text) {
    setTimeout(function() {
      that.clear_publish_text();
    }, 2000);
  }
};

LearnEditor.prototype.enable_text_editor = function($element) {
  const options = this.tinymce_options();
  $element.each(function(i, e) {
    tinymce.execCommand("mceAddEditor",false, { id: $(e).attr("id"), options: options });
  });
};

LearnEditor.prototype.disable_text_editor = function($element) {
  $element.each(function(i, e) {
    tinymce.execCommand("mceRemoveEditor",false, { id: $(e).attr("id"), options: {} });
  });
};

LearnEditor.prototype.centerInView = function($element) {
  if (!this.is_in_view($element)) {
    $('html,body').animate({
          scrollTop: $element.offset().top - 150}, 20);
  }
}

LearnEditor.prototype.inject_button_bars = function() {
  var that = this;
  //clear out the existing bars
  this.remove_button_bars();

  if ($('.bottom-button-bar').length <= 0) {
    $('.editor-container').append(this.renderButtonBar());
    $('.button-bar').removeClass('button-bar').addClass('bottom-button-bar').find('.cancel').remove();
  }

  $('.editor-container').find('.element').before(templates.editor_button_line);
};

LearnEditor.prototype.handle_button_bar_display = function() {
  var buttonLine = '.editor-button-line';
  var timeout;

  function bar_open() {
    return $(buttonLine).find('.button-bar-buttons').length > 0;
  }

  function show_bar($element) {
    clearTimeout(timeout);
    $(buttonLine).css('visibility', 'hidden');
    $element.next(buttonLine).css('visibility', 'visible').find(buttonLine).css('visibility', 'visible');
    $element.prev(buttonLine).css('visibility', 'visible').find(buttonLine).css('visibility', 'visible');
  }

  $('.editor-container').find('.element').on('mouseenter', function() {
    if (bar_open()) {
      return;
    }

    show_bar($(this));
  }).on('mouseleave', function(event) {
    if (bar_open()) {
      return;
    }

    var $currentElement = $(event.toElement || event.relatedTarget);

    // don't hide the bar if hovering on it
    if ($currentElement.closest(buttonLine).length) {
      return;
    }

    $(buttonLine).css('visibility', 'hidden');
    if ($currentElement.closest('.element').length) {
      show_bar($currentElement);
    }
  });

  timeout = setTimeout(function() {
    $(buttonLine).css('visibility', 'hidden');
  }, 2000);
}

LearnEditor.prototype.remove_button_bars = function() {
  $('.editor-button-line, .button-bar').remove();
};

LearnEditor.prototype.enable_bottom_button_bar = function(should_enable) {
  if (should_enable) {
    $('.bottom-button-bar a, .bottom-button-bar span').removeClass('disabled');
  } else {
    $('.bottom-button-bar a, .bottom-button-bar span').addClass('disabled');
  }
};

LearnEditor.prototype.page_title_handler = function() {
  var that = this;

  $(document).on('click', '.editor-page-title-edit-link', function(event) {
    event.preventDefault();

    if (that.is_editor_enabled()) {
      // prevent edits to page title if already editing.
      alert('Please save your existing edit prior to editing the page title.');
      return;
    }

    $(event.target).closest('form').submit();
  });
};

LearnEditor.prototype.reorganize_products = function() {
  $('.reorganize-products-button').on('click', function(event) {
    event.preventDefault();

    $('.product-image').hide();
    $('.product-details').hide();

  });
};

//table element image modifiers
LearnEditor.prototype.prepend_table_image_modifiers = function() {
  $('.table-image').prepend("<span class='editor-table-build-image'>" +
      "<span class='fileinput-button replace-button'>replace<input class='editor-table-replace-build-image' type='file' name='files'></span>" +
      "<a href='#' class='editor-table-license-build-image'>update license</a>" +
      "<div class='clear'</div>" +
      "</span>");
  this.replace_image_upload_init();
};

LearnEditor.prototype.replace_image_upload_init = function() {
  var that = this;

  $('.editor-table-replace-build-image').fileupload({
    dataType: 'html',
    progressInterval: 20,
    bitrateInterval: 100,
    add: function(e, data) {
      $(this).closest('.editor-table-cell-image-editor').find('.medium-placeholder, .table-image img').replaceWith(templates.image_placeholder);
      data.submit();
    },
    done: function (e, data) {

      $(this).parents('.table-image').replaceWith(data.result);
      that.prepend_table_image_modifiers();
    }
  }).on('fileuploadadd', function (e, data) {
    var url, asset, page_id = $('input[name$="page_id"]').val();
    asset = parseInt($(this).parents('.table-image').find('img').attr('class'), 10);
    url = '/pages/' + page_id + '/assets/' + asset + '/replace?update_type=table';
    data.url = url;
  });
};

LearnEditor.prototype.scroll_to_bottom = function(height) {
  var doc_height = $(document).height() + 20;
  if (height > 0) {
    doc_height += height;
  }
  $("html, body").animate({ scrollTop: doc_height-$(window).height() }, 20);
};

LearnEditor.prototype.center_in_view = function($element) {
  if (!this.is_in_view($element)) {
    $('html,body').animate({
        scrollTop: $element.offset().top - 150}, 20);
  }
};

LearnEditor.prototype.is_in_view = function($element) {
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();

  var elemTop = $element.offset().top;
  var elemBottom = elemTop + $element.height();
  var elemDisplayNotNone = $element.css("display") !== "none";

  return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop) && elemDisplayNotNone);
};

// cange name to is_editable and reverse logic maybe?
LearnEditor.prototype.is_editor_enabled = function() {
  return (this.editor_locked || this.prevent_navigation());
};

LearnEditor.prototype.prevent_navigation = function() {
  return (this.save_in_progress || this.editing_element);
};

LearnEditor.prototype.legacy_save = function(save_comment) {
  var that = this;

  $.ajax({
    url: $('#editor-form').attr("action"),
    type: 'PUT',
    contentType: 'application/json',
    data: JSON.stringify(this.formData(save_comment)),
    dataType: 'json'
  }).done(that.save_response.bind(that)).fail(that.save_response.bind(that));
};

LearnEditor.prototype.save_response = function(response) {
  var that = this;

  var handle_save_success = function(response) {
    if (window.DEBUG) {
      that.saveFinish = performance.now();
      console.log("Total time: " + (that.saveFinish - that.saveStart) + " milliseconds.");
    }

    if (!that.is_image_processing()) {
       // only replace content if images aren't still uploading
       that.$element.html(response.content);
    }
    that.save_in_progress = false;
    that.clear_publish_text();
    that.enableEditor();

    // other element components may need to know when a save is fully finished
    // to finalize display (code element and prettyprint)
    that.$element.trigger('save-page-complete');
  };

  var handle_save_failure = function(response) {
    that.save_in_progress = false;
    var errors = "";

    if (response.errors) {
      $.each( response.errors, function( base, model_errors ) {
        errors = errors + model_errors.map(function(error) {
          return base + ": " + error + "<br/>";
        });
      });
    }

    if (response.error) {
      errors = errors + response.error;
    }

    $('.alert-js .alert-js-content').html("There was an error saving. Please back up your new content, and try again.<br/>" + errors);
    $('.alert-js').css('width', $('.alert-js').parent().innerWidth()).show();

    that.enableEditor();
    that.set_publish_text("Error", true, true);
  };

  if (response.success) {
    handle_save_success(response);
  } else {
    handle_save_failure(response);
  }
};

LearnEditor.prototype.is_image_processing = function () {
  return $('.build-image-placeholder:first').length >= 1;
};

LearnEditor.prototype.formData = function(save_comment) {
  var form_content = $('#editor-form').clone();
  form_content.find('.animated-gif, .build-image-placeholder, .icon-warning-sign, .icon-exclamation-sign, .fa-exclamation-circle, .fa-exclamation-triangle, .button-bar, .bottom-button-bar, .editor-button-line, .build-image-options, .editor-table-outer-links, .editor-table-add-row, .editor-table-add-column, .editor-table-delete-table, .editor-table-build-image').remove();
  form_content = form_content.html();

  var form_data = $('#editor-form').serializeJSON();
  if ( !form_data['page'] ) { form_data['page'] = {}}
  form_data['page']['title'] = $('input[name$="title"]').val();
  form_data['comment'] = save_comment;
  form_data['content'] = form_content;

  return form_data
}

LearnEditor.prototype.save_page = function(save_comment) {
  var that = this;
  this.save_in_progress = true;
  this.editing_element = false;

  this.set_publish_text("Saving", true);

  if (this.saveWithCable) {
    console.log('enable cable save!')
    save(form_data);
  } else {
    this.legacy_save(save_comment);
  }

  if (window.DEBUG) {
    this.saveStart = performance.now();
  }
};

LearnEditor.defaults = LearnEditor.prototype.defaults;

export default LearnEditor;
